export const livingCells = () => {

    const tabLinks = document.querySelectorAll('.living-cells--tabs--item--link');
    const tabContents = document.querySelectorAll('.living-cells--tabs--content--inner');

    if (!tabLinks.length) return;

    tabLinks.forEach(link => {

        link.addEventListener('click', (e) => {

            e.preventDefault();

            const target = e.currentTarget.getAttribute('href');

            tabLinks.forEach(link => {
                link.classList.remove('is-active');
            });

            link.classList.add('is-active');

            tabContents.forEach(content => {
                content.classList.remove('is-showing');
            });

            const targetContent = document.querySelector(target);

            if (targetContent) {
                targetContent.classList.add('is-showing');
            } else {
                console.warn('Target element not found:', target);
            }

        });

    });

}